import { useCallback, useEffect, useState, createRef } from 'react'
import { useEffectOnce } from 'usehooks-ts'
import styled from 'styled-components'
import { get } from 'http'

const IconPerson = ({
  tenant,
  colorMode,
  perc,
  dec,
  className,
  color,
  adjustRowHeight,
  estimationID,
  type,
  difference,
  total,
  showDiff,
}: {
  tenant?: object
  colorMode: string
  perc: number
  dec: number
  className?: string
  color?: string
  estimationID?: string
  type: string
  difference?: number
  total: number
  showDiff?: boolean
  adjustRowHeight?: (height: number) => void
}) => {
  const [isMobile, setIsMobile] = useState(false)
  const iconRef = createRef<SVGSVGElement>()
  const [windowWidth, setWindowWidth] = useState(0)

  const hexToRgb = function (hex: string) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    const r = result ? parseInt(result[1], 16) : 0
    const g = result ? parseInt(result[2], 16) : 0
    const b = result ? parseInt(result[3], 16) : 0
    return result ? '' + r + ', ' + g + ', ' + b : '0, 0, 0'
  }

  const getValue = function (dec: number, comma: number) {
    return dec + comma / 10
  }

  const getClass = function (
    type: string,
    difference: any,
    index: number,
    total: number,
    showDiff: any
  ) {
    let iconclass = 'active'
    if (type === 'parlament') {
      if (showDiff === true) {
        if (difference > 0 && index >= total - difference) {
          iconclass = 'over'
        } else if (difference < 0 && index >= total + difference) {
          iconclass = 'under'
        }
      } else if (difference < 0 && index >= total + difference) {
        iconclass = 'hidden'
      }
    }

    return iconclass
  }

  const getHeight = function () {
    const rect = iconRef.current
      ? iconRef.current.getBoundingClientRect()
      : null
    const iconClass = iconRef.current ? iconRef.current.className.baseVal : null
    if (adjustRowHeight && rect && iconClass.indexOf('p-0') >= 0) {
      const iconHeight = Math.round(rect.height)
      adjustRowHeight(iconHeight)
    }
  }

  const handleResize = function () {
    setWindowWidth(window.innerWidth)
    setIsMobile(window.innerWidth < 711)
  }

  useEffectOnce(() => {
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  useEffect(() => {
    getHeight()
  })

  return (
    <Iconperson
      className={className}
      dec={dec}
      rgbColor={hexToRgb(color ? color : '#202346')}
      estimationID={estimationID ? estimationID : 'default'}
      colorMode={colorMode}
      // onClick={() => console.log(dec)}
    >
      <StyledSVG
        viewBox='0 0 100 125'
        preserveAspectRatio='none'
        ref={iconRef}
        className={className}
      >
        <defs>
          <linearGradient
            id={'bottom-gradient-' + estimationID + '-' + dec}
            x='10'
            y='10'
            rx='15'
            ry='15'
          >
            <stop
              offset='0%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 1)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='9%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 1)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='10%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 1)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='11%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 2)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='19%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 2)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='20%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 2)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='21%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 3)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='29%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 3)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='30%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 3)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='31%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 4)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='39%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 4)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='40%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 4)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='41%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 5)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='49%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 5)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='50%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 5)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='51%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 6)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='59%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 6)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='60%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 6)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='61%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 7)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='69%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 7)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='70%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 7)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='71%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 8)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='79%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 8)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='80%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 8)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='81%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 9)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='89%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 9)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='90%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 9)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='91%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec + 1, 0)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='100%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec + 1, 0)
                  ? 'active'
                  : 'inactive'
              }
            />
          </linearGradient>
          <linearGradient
            id={'top-gradient-' + estimationID + '-' + dec}
            x='10'
            y='10'
            rx='15'
            ry='15'
          >
            <stop
              offset='0%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 3)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='16%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 3)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='17%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 4)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='33%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 4)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='34%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 5)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='35%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 5)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='50%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 5)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='51%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 6)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='67%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 6)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='68%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 6)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='69%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 7)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='84%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 7)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='85%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 7)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='86%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 8)
                  ? 'active'
                  : 'inactive'
              }
            />
            <stop
              offset='100%'
              className={
                type === 'parlament'
                  ? getClass(type, difference, dec, total, showDiff)
                  : perc >= getValue(dec, 8)
                  ? 'active'
                  : 'inactive'
              }
            />
          </linearGradient>
        </defs>
        <g
          id='bottom'
          className={getClass(type, difference, dec, total, showDiff)}
        >
          <path d='M93.8,117.3V99.1c0-19.3-13.8-35-30.7-35H36.8c-16.9,0-30.7,15.6-30.7,35v18.1H93.8z' />
        </g>
        <g
          id='top'
          className={getClass(type, difference, dec, total, showDiff)}
        >
          <ellipse cx='50' cy='33' rx='25.2' ry='25.2' />
        </g>
        <g
          id='outline'
          className={getClass(type, difference, dec, total, showDiff)}
        >
          <path
            d='M62,63.8H38c-17.5,0-31.8,15.4-31.8,34.3v19.6h87.7V98.1C93.8,79.2,79.6,63.8,62,63.8z M13.7,110.4V98.1
		c0-14.9,10.9-27,24.3-27h24c13.4,0,24.3,12.1,24.3,27v12.3H13.7z'
          />
          <path
            d='M50,7.7C36.1,7.7,24.8,19,24.8,33c0,13.9,11.3,25.2,25.2,25.2S75.2,46.9,75.2,33C75.2,19,63.9,7.7,50,7.7z
		 M50,51c-10,0-18-8.1-18-18s8.1-18,18-18c10,0,18,8.1,18,18S60,51,50,51z'
          />
        </g>
      </StyledSVG>
    </Iconperson>
  )
}
const Iconperson = styled.div<{
  dec: number
  rgbColor: string
  estimationID: string
  colorMode: string
}>`
  #bottom {
    fill: url(${(prop) =>
      '#bottom-gradient-' + prop.estimationID + '-' + prop.dec});
  }
  #top {
    fill: url(${(prop) =>
      '#top-gradient-' + prop.estimationID + '-' + prop.dec});
  }
  #outline {
    display: none;
  }
  #outline.under {
    fill: var(--under-stroke-color);
    display: block;
  }

  .active {
    stop-color: rgba(${(prop) => prop.rgbColor + ', 1'});
  }
  .inactive {
    stop-color: rgba(
      ${(prop) => (prop.colorMode === 'dark' ? '85, 85, 85' : '220, 220, 220')},
      1
    );
    _transition: all 2s;
  }
  .under {
    stop-color: rgba(
      ${(prop) =>
        prop.colorMode === 'dark' ? '205, 226, 238' : '205, 226, 238'},
      0
    );
    _transition: all 2s;
  }
  .over {
    stop-color: rgba(
      ${(prop) => (prop.colorMode === 'dark' ? '158, 39, 47' : '211, 52, 63')},
      1
    );
    _transition: all 2s;
  }
  .hidden {
    stop-color: rgba(
      ${(prop) => (prop.colorMode === 'dark' ? '0, 0, 0' : '255, 255, 255')},
      0
    );
  }
`

const StyledSVG = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
`

export default IconPerson
